<!-- Dual FAB: collapsed = left icon only; click expands full logo then opens shell -->
<div class="ai-fab-stack" *ngIf="!open">
  <button
    type="button"
    class="ai-fab ai-fab--giada"
    [class.ai-fab--expanded]="fabExpanded === 'giada'"
    dwsPermission="GIADA_USE"
    dwsPermissionDenyMode="hide"
    (click)="onFabClick('giada', $event)"
    [attr.aria-label]="'Open gIAda' | translate"
    [attr.aria-expanded]="fabExpanded === 'giada'"
  >
    <span class="ai-fab__logo-clip">
      <img
        class="ai-fab__logo"
        src="assets/images/giada-logo.png"
        alt="gIAda"
      />
    </span>
  </button>
  <button
    type="button"
    class="ai-fab ai-fab--waine"
    [class.ai-fab--expanded]="fabExpanded === 'waine'"
    dwsPermission="AI_AGENT_USE"
    dwsPermissionDenyMode="hide"
    (click)="onFabClick('waine', $event)"
    [attr.aria-label]="'Open wAIne Agents' | translate"
    [attr.aria-expanded]="fabExpanded === 'waine'"
  >
    <span class="ai-fab__logo-clip">
      <img
        class="ai-fab__logo"
        src="assets/images/waine-agents-logo.png"
        alt="wAIne Agents"
      />
    </span>
  </button>
</div>

<!-- Docked backdrop -->
<div
  class="ai-shell-backdrop"
  *ngIf="open && isDocked"
  (click)="close()"
></div>

<!-- Shell: docked right drawer OR detached always-on-top card -->
<aside
  *ngIf="open"
  class="ai-shell"
  [class.ai-shell--docked]="isDocked"
  [class.ai-shell--detached]="isDetached"
  [class.ai-shell--giada]="showGiadaBrand"
  [style.left.px]="isDetached ? detachedX : null"
  [style.top.px]="isDetached ? detachedY : null"
  role="dialog"
  [attr.aria-label]="(showGiadaBrand ? 'gIAda' : 'wAIne Agent') | translate"
>
  <header
    class="ai-shell__header"
    (mousedown)="onDragStart($event)"
    [class.ai-shell__header--draggable]="isDetached"
  >
    <div class="ai-shell__brand">
      <div class="ai-shell__brand-mark" aria-hidden="true">
        <img
          *ngIf="showGiadaBrand"
          class="ai-shell__brand-logo"
          src="assets/images/giada-logo.png"
          alt=""
        />
        <img
          *ngIf="!showGiadaBrand"
          class="ai-shell__brand-logo"
          src="assets/images/waine-agents-logo.png"
          alt=""
        />
      </div>
      <span class="ai-shell__beta" *ngIf="!showGiadaBrand">{{ "Beta" | translate }}</span>
    </div>
    <div class="ai-shell__acts">
      <button
        type="button"
        class="ai-icon-btn"
        (click)="newChat()"
        [disabled]="streaming || loadingSession"
        [attr.aria-label]="'New chat' | translate"
        [wsTooltip]="'New chat' | translate"
      >
        <svg viewBox="0 0 24 24" aria-hidden="true" focusable="false">
          <path fill="currentColor" d="M19 13h-6v6h-2v-6H5v-2h6V5h2v6h6v2z"/>
        </svg>
      </button>
      <button
        type="button"
        class="ai-icon-btn"
        *ngIf="isDocked"
        (click)="detach()"
        [attr.aria-label]="'Detach' | translate"
        [wsTooltip]="'Detach' | translate"
      >
        <svg viewBox="0 0 24 24" aria-hidden="true" focusable="false">
          <path fill="currentColor" d="M14 3v2h3.59l-9.83 9.83 1.41 1.41L19 6.41V10h2V3h-7zM5 5v14h14v-7h-2v5H7V7h5V5H5z"/>
        </svg>
      </button>
      <button
        type="button"
        class="ai-icon-btn"
        *ngIf="isDetached"
        (click)="dock()"
        [attr.aria-label]="'Dock to side' | translate"
        [wsTooltip]="'Dock to side' | translate"
      >
        <svg viewBox="0 0 24 24" aria-hidden="true" focusable="false">
          <path fill="currentColor" d="M3 5v14h18V5H3zm8 12H5V7h6v10zm8 0h-6V7h6v10z"/>
        </svg>
      </button>
      <button
        type="button"
        class="ai-icon-btn"
        *ngIf="product === 'waine'"
        (click)="expandFullPage($event)"
        [attr.aria-label]="'Open full page' | translate"
        [wsTooltip]="'Open full page' | translate"
      >
        <svg viewBox="0 0 24 24" aria-hidden="true" focusable="false">
          <path fill="currentColor" d="M7 14H5v5h5v-2H7v-3zm-2-4h2V7h3V5H5v5zm12 7h-3v2h5v-5h-2v3zM14 5v2h3v3h2V5h-5z"/>
        </svg>
      </button>
      <button
        type="button"
        class="ai-icon-btn"
        (click)="close()"
        [attr.aria-label]="'Close' | translate"
        [wsTooltip]="'Close' | translate"
      >
        <svg viewBox="0 0 24 24" aria-hidden="true" focusable="false">
          <path fill="currentColor" d="M19 6.41 17.59 5 12 10.59 6.41 5 5 6.41 10.59 12 5 17.59 6.41 19 12 13.41 17.59 19 19 17.59 13.41 12 19 6.41z"/>
        </svg>
      </button>
    </div>
  </header>

  <div class="ai-shell__error" *ngIf="error">{{ error }}</div>
  <div class="ai-shell__quota" *ngIf="quotaWarning">{{ quotaWarning }}</div>

  <div class="ai-shell__messages" #messagesEl>
    <div
      *ngIf="!messages.length && !streaming && !loadingSession"
      class="ai-shell__empty"
    >
      <div class="ai-shell__empty-card">
        <img
          class="ai-shell__empty-giada"
          [src]="showGiadaBrand ? 'assets/images/giada-logo.png' : 'assets/images/waine-agents-logo.png'"
          [alt]="showGiadaBrand ? 'gIAda' : 'wAIne Agents'"
        />
        <p *ngIf="!showGiadaBrand">{{ "Ask something about contacts, orders or reservations…" | translate }}</p>
        <p *ngIf="showGiadaBrand">{{ "Ask how Wine Suite works, or open a support ticket…" | translate }}</p>
      </div>
    </div>

    <div
      *ngFor="let m of messages"
      class="ai-msg"
      [class.ai-msg--user]="m.role === 'user'"
      [class.ai-msg--assistant]="m.role === 'assistant'"
    >
      <div
        class="ai-msg__bubble ai-agent-md"
        [innerHTML]="m.text | aiAgentMarkdown"
      ></div>
      <div
        class="ai-msg__downloads"
        *ngIf="m.role === 'assistant' && m.downloads?.length"
      >
        <button
          type="button"
          class="ai-msg__download-btn"
          *ngFor="let dl of m.downloads"
          (click)="onDownloadClick(dl, $event)"
        >
          {{ dl.label | translate }}
        </button>
      </div>
    </div>
    <div *ngIf="loadingSession && !messages.length" class="ai-shell__empty">
      <div class="ai-agent-ws-loader">
        <mat-spinner diameter="36"></mat-spinner>
        <img
          class="ai-agent-ws-loader__logo"
          [src]="showGiadaBrand ? 'assets/images/giada-logo.png' : 'assets/images/waine-agents-logo.png'"
          [alt]="showGiadaBrand ? 'gIAda' : 'wAIne Agents'"
        />
      </div>
    </div>
    <div *ngIf="streaming" class="ai-shell__responding" aria-live="polite">
      <img
        *ngIf="!respondingGifFailed"
        class="ai-shell__responding-gif"
        src="assets/images/ai-agent-responding.gif"
        alt=""
        (error)="onRespondingGifError()"
      />
      <span
        *ngIf="respondingGifFailed"
        class="ai-shell__responding-fallback"
        aria-hidden="true"
      >
        <span></span><span></span><span></span>
      </span>
      <span class="ai-shell__responding-label">{{ "Responding…" | translate }}</span>
    </div>
  </div>

  <div class="ai-shell__composer">
    <input
      #inputEl
      class="ai-shell__input"
      type="text"
      name="aiAgentPanelInput"
      [(ngModel)]="input"
      [disabled]="streaming"
      [placeholder]="'Ask…' | translate"
      (keydown.enter)="$event.preventDefault(); send()"
      autocomplete="off"
    />
    <button
      type="button"
      class="ai-shell__send"
      [disabled]="!canSend"
      (click)="send()"
    >
      {{ "Send" | translate }}
    </button>
  </div>
</aside>
